import routerOptions0 from "/builds/masterbranch1/smg-callcentre/smg-callcentre-admin/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}